export default "__VITE_ASSET__D4K7Gci9__"